/** PURE_IMPORTS_START ._IfObservable PURE_IMPORTS_END */
import { IfObservable } from './IfObservable';
export var _if = IfObservable.create;
//# sourceMappingURL=if.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/if.js
// module id = 774
// module chunks = 0